<template>
  <div class="lawlex-custom-card">
      {{ $t('msg_something_went_wrong') }}
  </div>
</template>

  <script>
  export default {
    name: "SomethingWentWrong",
  };
  </script>
